/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Toss_LabelInputs */



/**
* | output |
* | --- |
* | "Toss:" |
*
* @param {Tournament_Toss_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_toss_label = /** @type {((inputs?: Tournament_Toss_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Toss_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tirage :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sorteo:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sorteio:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sorteggio:")
	return /** @type {LocalizedString} */ ("Toss:")
});